import { NgModule } from '@angular/core';
import { CartListGroupRowComponent } from '../cart-list-group-row/cart-list-group-row.component';
import { CartListItemRowComponent } from '../cart-list-item-row/cart-list-item-row.component';
import { CartListSubgroupRowComponent } from '../cart-list-subgroup-row/cart-list-subgroup-row.component';
import { ItemReviewStatusComponent } from '../../../../shared/components/item-review-status/item-review-status.component';
import { CurrencyPipe, NgClass, NgForOf, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault, SlicePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { SharedPipeModule } from '../../../../shared/pipes/shared-pipe.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { ItemReviewStatusSumComponent } from '../../../../shared/components/item-review-status/item-review-status-sum/item-review-status-sum.component';
import { MatTabsModule } from '@angular/material/tabs';
import { CartListComponent } from './cart-list.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SharedModule } from '../../../../shared/shared.module';

@NgModule({
	imports: [
		SharedPipeModule,
		ItemReviewStatusComponent,
		NgSwitchCase,
		MatIconModule,
		NgSwitch,
		NgIf,
		NgForOf,
		NgSwitchDefault,
		MatMenuModule,
		MatExpansionModule,
		ItemReviewStatusSumComponent,
		MatTabsModule,
		CurrencyPipe,
		NgClass,
		MatPaginatorModule,
		SlicePipe,
		SharedModule,
	],
	declarations: [CartListComponent, CartListGroupRowComponent, CartListItemRowComponent, CartListSubgroupRowComponent],
	exports: [CartListComponent, CartListGroupRowComponent, CartListItemRowComponent, CartListSubgroupRowComponent]
})
export class CartListModule {}
